<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref } from "vue";
import { errorAlert } from "../plugins/alert";
import Encoding from 'encoding-japanese';

const props = defineProps({
    value: {
      type:Object,
      required:true
    },
    encode: {
      type:String,
      default : () => {
        return '';
      }
    },
    handler: {
      type:Function,
    },
    loadComplete: {
      type:Function,
    },
    loadProgress: {
      type:Function,
    },
    loadStart: {
      type:Function,
    },
})
const fileValue = ref(props.value);
const fileData = ref([]);

// ダブルクォートで囲われた値を、クォートを除いた値に変換して分割する
const parseCsvLine = (line: string) => {
  const result = [];
  let field = '';
  let inQuotes = false;
  for (let i=0;i<line.length;i++) {
    const char = line[i];
    if (inQuotes) {
      if (char === '"') {
        if (line[i+1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += char;
      }
    } else if (char === '"' && field === '') {
      inQuotes = true;
    } else if (char === ',') {
      result.push(field);
      field = '';
    } else {
      field += char;
    }
  }
  result.push(field);
  return result;
}

const onFileUpload = (e) => {
  fileValue.value = e.target.files[0];
  if (typeof props.handler !== 'undefined') {
    props.handler(fileValue.value);
  }
  loadCsv(fileValue.value);
}
const loadCsv = (csv) => {
    const reader = new FileReader()
    reader.onloadstart = (e) => {
      if (typeof props.loadStart !== 'undefined') {
        props.loadStart();
      }
    }
    reader.onload = (e) => {
      const codes = new Uint8Array(e.target.result);
      const unicodeString = Encoding.convert(codes, {
        to: 'UNICODE',
        from: (!props.encode ? Encoding.detect(codes) : props.encode as any),
        type: 'string',
      });
      fileData.value.splice(0);
      let fileList = unicodeString.split(/\r\n|\n/);
      for (let i=0;i<fileList.length;i++) {
        let div = parseCsvLine(fileList[i]);
        fileData.value.push(div);
      }
      if (typeof props.loadComplete !== 'undefined') {
        props.loadComplete(fileData.value);
      }
    }
    reader.onerror = (e) => {
      errorAlert('読み込みに失敗しました。');
      if (typeof props.loadComplete !== 'undefined') {
        props.loadComplete(null);
      }
    }
    reader.onprogress = (e) => {
      if (typeof props.loadProgress !== 'undefined') {
        props.loadProgress(e.loaded,e.total);
      }
    }
    reader.readAsArrayBuffer(csv);
}
</script>

<style scoped lang='sass'>
</style>

<template>
<div>
  <input type="file" @change="onFileUpload">
</div>
</template>
